import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useNavigation, useParams } from "react-router";
// import { useMatomoPageViewsTracking } from "../analytics/useMatomoPageViewsTracking";
// import { useMatomoTagManager } from "../analytics/useMatomoTagManager";
// import { useMatomoTrackEvent } from "../analytics/useMatomoTrackEvent";
import t from "../i18n";
import { hrefWithEditedSearchParams } from "../lib/hrefWithEditedSearchParams";
// import { useIsCurrentRouteMatching } from "../router/helpers/path";
import { useModals } from "@ui/lib/hooks/useModal";
import { SHARED_URL_APPLIED } from "@ui/lib/urlTools";
import MainLayout from "@ui/MainLayout";
import Modal from "@ui/Modal";
import useToasts from "@ui/Toast/useToasts";
import ChangeUserNameModalForm from "./Administration/Users/ChangeUserNameModalForm";
import { AppHeader } from "./App/Header";
import Legals from "./App/LegalsModal";
import { useProject } from "../api/useProjects";
import { useSettings } from "../api/useSettings";
import { useUser } from "../api/useUser";
import setDocumentTitle from "../lib/setDocumentTitle";
import { useHandle } from "../router/helpers/handle";
import { isProjectHomePath, resolveDocumentTitle } from "../router/helpers/DocumentTitle";

export const Shell = () => {
  const user = useUser();
  const location = useLocation();
  const navigation = useNavigation();
  const { projectId } = useParams();
  const project = useProject(projectId ?? "");
  const settings = useSettings();
  const documentTitle = useHandle("documentTitle");
  const projectDocumentTitle = useHandle("projectDocumentTitle");
  const { modal, openModal, closeModal } = useModals<"legals" | "setName">();
  const effectiveProjectDocumentTitle = React.useMemo(() => {
    if (settings.NEW_NAVIGATION_ENABLED && isProjectHomePath(location.pathname))
      return (projectName: string) =>
        `${projectName} | ${t("project.document.title.new_navigation.summary")}`;

    return projectDocumentTitle;
  }, [location.pathname, projectDocumentTitle, settings.NEW_NAVIGATION_ENABLED]);

  useEffect(() => {
    if (!location.pathname.includes("administration")) openModal("legals");
    if (user.name === null) openModal("setName");
  }, [location.pathname, user, openModal]);

  useEffect(() => {
    const nextTitle = resolveDocumentTitle({
      documentTitle,
      projectDocumentTitle: effectiveProjectDocumentTitle,
      projectName: project?.name,
      preserveDuringNavigation: navigation.state !== "idle",
    });
    if (nextTitle !== null) setDocumentTitle(nextTitle);
  }, [documentTitle, effectiveProjectDocumentTitle, navigation.state, project?.name]);

  //   const authentication = useAuthentication();
  //   const authorized = authentication || oidcUserManager === null;

  useShareableSuccessNotifier(t("project.permalink.loaded"));

  // const trackEvent = useMatomoTrackEvent();
  // useMatomoTagManager();
  // useMatomoPageViewsTracking();

  // const isMatchingFaultEvents = useIsCurrentRouteMatching("/projects/:projectId/fault-events");
  // if (isMatchingFaultEvents) {
  //   trackEvent({
  //     category: "Events",
  //     action: "Navigate to Fault Events page",
  //     name: "Open Fault Events page",
  //   });
  // }

  return (
    <>
      <Legals openModal={modal === "legals"} closeModal={closeModal} />
      <Modal
        title={t("users.modal.create.user_name.title")}
        isOpen={modal === "setName"}
        onRequestClose={closeModal}
        closable={false}
      >
        <ChangeUserNameModalForm onRequestClose={closeModal} />
      </Modal>
      <MainLayout header={<AppHeader />}>
        <Outlet />
      </MainLayout>
    </>
  );
};

const useShareableSuccessNotifier = (sucessMessage: string) => {
  const { search } = useLocation();
  const { addToast } = useToasts();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (new URLSearchParams(search).has(SHARED_URL_APPLIED)) {
      addToast("success", sucessMessage);
      void navigate(
        hrefWithEditedSearchParams(sp => sp.delete(SHARED_URL_APPLIED), false),
        { replace: true },
      );
    }
  }, [addToast, navigate, search, sucessMessage]);
};
